import React from 'react'
import './impressum.css'
import backgroundImg from '../ui/Backdrop_home.png'

function Impressum() {
  return (

    <>

      <div id='backdropContainer'>

        <img src={backgroundImg} alt="Ein Bild mit Kaleidoskopmuster" id='Backdrop_impressum' />
      </div>
      <div>
        <div className='title_impressum'>Impressum</div>

        <div className='block'>
          <p>Kampnagel Internationale Kulturfabrik GmbH</p>
          <p>Jarrestraße 20</p>
          <p>22303 Hamburg</p>


          <p>Deutschland</p>

          <p>Telefon: +49 40 270 949-0</p>
          <p>mail@kampnagel.de</p>

          <p>Registergericht und Handelsregister-Nummer: HRB 52149 Amtsgericht Hamburg</p>
          <p>Umsatzsteueridentifikations-Nummer: DE 154233843</p>

          <p>Vertreten durch die Geschäftsführung: Intendantin Amelie Deuflhard und Jonas Zipf (V.i.S.d.P.)</p>

          <p>Vorsitzender des Aufsichtsrats: Dr. Carsten Brosda</p>


          <h1>COPYRIGHT</h1>

          <p>Das Layout der Homepage, die verwendeten Grafiken und Bilder sowie die einzelnen Beiträge sind urheberrechtlich geschützt.</p>
        </div>






      </div>

    </>

  )
}

export default Impressum